<template>
  <div id="container">
    <!-- {{AccountInfo}} -->
    <el-dialog :title="title" :lock-scroll="false" :visible="dialogVisible" :before-close="handleClose">
      <div class="dialogData">
        <article class="account_dialogData">
          <p>{{$t('alert.closeOfTrd')}}</p>
          <p>{{$t('alert.closeOfA')}}</p>
          <p>{{$t('alert.closeOfB')}}</p>
          <p>{{$t('alert.closeOfOpened')}}</p>
          <p>{{$t('alert.closeOfHistorical')}}</p>
        </article>
        <ul class="account_ul">
          <!-- 没有未支付订单
          没有竞拍中的商品
          清空CHP  
          取消订阅（应该是关注吧？） -->
          <li><span :class="AccountInfo.AuctionCount>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noOngBids')}}</li>
          <li><span :class="AccountInfo.Selling>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noListCard')}}</li>
          <li><span :class="AccountInfo.SumMoney<0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noChp')}}</li>
          <li><span :class="AccountInfo.BuyReceive>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noUnconfirmedPurchased')}}</li>
          <li><span :class="AccountInfo.BuyWaitPay>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noUnpaidPurchased')}}</li>
          <li><span :class="AccountInfo.SellReceive>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noUnconfirmedSold')}}</li>
          <li><span :class="AccountInfo.SellWaitSend>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noUnpaidSold')}}</li>
          <li><span :class="AccountInfo.IsDove>0?'el-icon-error':'el-icon-success'"></span>{{$t('alert.noReason')}}</li>
        </ul>
        <article class="account_dialogData">
          <p v-html="$t('alert.closeOfAbove')"></p>
        </article>
        <div slot="footer" class="dialog_footer">
          <el-button type="primary" @click="SetAccount()" v-if="!isAccount">{{$t('base.confirm')}}</el-button>
          <el-button @click="dialogVisible = false">{{$t('base.cancel')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <h1 class="full_layout terms_title">{{$t('title.cancelAccount')}}</h1>
    <div class="full_layout text_blue detail">
      <section>
        <h3>Close account and delete data</h3>
      </section>
    </div>
    <div class="orange">
    </div>
    <div class="full_layout flex_layout_between terms_article">
      <div class="article_box">
        <p>{{$t('alert.closeOfOne')}}</p>
        <p>{{$t('alert.closeOfTwo')}}</p>
        <div class="set_btn" v-if="!AccountStatus">
          <el-button type="primary" @click="dialogVisible = true">{{$t('base.confirmDelete')}}</el-button>
          <el-button class="cancel" @click="goto('back')">{{$t('base.cancel')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo, toLogout } from "@/api/public";
import qs from 'qs'
export default {
  name: 'index',
  data() {
    return {
      AccountStatus: false,
      AccountInfo: '',
      isAccount: false,
      ifAccount: false,
      userInfo: null,
      dialogVisible: false,
      title: this.$t('title.cancellationWarn')
    }
  },
  mounted() {},
  created() {
    this.userInfo = getInfo()
    bus.$emit('headerTitle', this.$t('title.newPlaceToBuy'));
    this.isSeller()
    //this.GetStatus()
    //this.GetInfo()
  },
  methods: {
    //获取用户是否是卖家
    isSeller() {
      this.GetStatus(this.userInfo.IsSeller)
      this.GetInfo(this.userInfo.IsSeller)
      //this.IsSeller=this.userInfo.this.userInfo
      //console.log(this.userInfo)
    },
    //获取买家注销申请的状态
    GetStatus(type) {
      let that = this;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      let url = this.$interface.GetAccountStatus
      if (type) {
        url = this.$interface.GetSellerAccountStatus
      }
      this.$get(url, data).then(res => {
        if (res.result != 0) {
          if (res.data == -1) {
            that.AccountStatus = false
          }
        } else {
          if (res.data == -1) {
            that.AccountStatus = false
          } else {
            that.AccountStatus = true
          }
        }
        //console.log(res)
      })
    },
    //获取买家账号的详细信息
    GetInfo(type) {
      let that = this;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      let url = this.$interface.GetAccountInfo
      if (type) {
        url = this.$interface.GetSellerAccountInfo
      }
      this.$get(url, data).then(res => {
        if (res.result != 0) {
          that.AccountInfo = res.data
          let result = res.data
          console.log("result", result)
          if (result.AuctionCount <= 0 && result.BuyWaitPay <= 0 && result.BuyReceive <= 0 && result.SellWaitSend <= 0 && result.SellReceive <= 0 && result.SumMoney >= 0 && result.Selling <= 0&& result.IsDove<=0) {
            // if(result.AuctionCount>0||result.BuyWaitPay>0||result.BuyReceive>0||result.SellWaitSend>0||result.SellReceive>0||result.SumMoney<0||result.Selling>0){
            that.ifAccount = true
          } else {
            that.ifAccount = false
          }
          console.log("ifAccount", that.ifAccount)
        }
        //console.log(res)
      })
    },
    //买家提交注销申请
    SetAccount() {
      let that = this;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      let url = this.$interface.SetAccount
      if (that.userInfo.IsSeller) {
        url = this.$interface.SetSellerAccount
      }


      if (this.ifAccount == true) {
        this.$post(url, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.open()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        })
      } else {
        this.$message({
            type: 'error',
            message: this.$t('alert.closeTheDeal')
          });
      }
    },
    open() {
      this.$alert('<div class="txt_logout">'+this.$t('alert.logout')+'<span class="el-icon-success text_greed"></span></div>', '', {
        confirmButtonText: 'Sure',
        dangerouslyUseHTMLString: true,
        lockScroll: false,
        callback: action => {
          this.dialogVisible = false;
          toLogout('cardUser')
        }
      });
    },
    goto(val) {
      if (val == 'back') {
        this.$router.push({ path: '/mycardhobby/setting' })
      }
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";

.orange {
  padding: 0;
  height: 12px;
  background-color: #F0AD4E;
  margin-bottom: 40px;
}

.terms_article {
  justify-content: flex-end;
}

.set_btn {
  text-align: right;
  margin: 40px 0
}

.el-icon-error:before {
  color: #E02020;
}

.el-icon-success:before {
  color: #57A800;
}

.account_ul {
  margin-bottom: 20px;
}

.account_ul span {
  font-size: 16px;
  margin-right: 9px;
}

.account_ul li {
  line-height: 2;
}

.account_dialogData {
  color: #a0a0a0;
  margin-bottom: 20px;
}

.dialogBox {
  width: 875px;
}

</style>



// WEBPACK FOOTER //
// src/pages/terms/account.vue